var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rounded-3px bg-gray-12 p-1 font-mono text-11px leading-none tracking-tight text-vanilla-300",class:{ 'group-hover:bg-transparent group-[.is-active]:bg-transparent': !_vm.isStatic }},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.count))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }